module.exports = __webpack_public_path__ + "WealthCare Saver HSA Change Power of Attorney Form.pdf";